var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPushkin = function SvgPushkin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F44336",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.621 37.4c1.094-2.363 1.876-5.514-2.812-5.199m0 0c-3.5.378-3.126-1.417-2.5-2.363.312-.472.575-1.569.575-2.514m1.925 4.877c3.5-.378 8.484-4.231 12.39-3.601M9.885 27.324c-.325-1.087-.808-1.384-1.513-2.527-1.042-.052-2.72-.472-1.094-1.733C9.308 21.49 12.1 18.7 13.2 15.4M9.884 27.325c.84-.104 2.601-.337 2.919-.443m9.788 8.155c.486-.642 2.518-2.532 6.925-2.404s4.645-2.087 4.213-3.211c6.97 0 4.77-10.722.867-11.522 1.944-9.154-3.46-8.873-4.594-8.873C28.6 3.3 19.8 3.3 17.85 6.94c-7.95 0-2.45 7.36 3.05 7.36 5.995.752 5.5 3.3 5.5 5.5 0 0-.535 2.698-4.813 2.056C18.7 22 17.6 23.1 16.5 24.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F44336",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m16.147 17.075 2.581.963-.796.796"
  })));
};
export default SvgPushkin;